export default defineNuxtPlugin((nuxtApp) => {
  const globalStore = useGlobalStore()
  // @ts-ignore
  nuxtApp.$i18n.setLocale(globalStore.store.locale!)
})
